//index.js:
import axios from 'axios';
// import router from '@/router'
// import qs from "qs";//qs为序列化数据的js库
// axios.defaults.baseURL = '192.168.0.1'

//设置请求头
import store from '@/store'
axios.defaults.withCredentials = true
axios.defaults.headers.common["device"] = "H5";
//设置超时
// axios.defaults.timeout = 10000;
// document.token="214193166b384f168fcab7add1076d84";
// document.device="H5";
axios.interceptors.request.use(
    config => {
        console.log(localStorage.getItem('user_token'))
        // config.headers.token = store.state.token
        config.headers.token = localStorage.getItem('user_token')
        // const token = "214193166b384f168fcab7add1076d84";
        // token && (config.headers.Authorization = token);
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        if (response.status == 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        // if (302 === error.response.status) {
        //     // window.location.href="/"//此处加跳转链接
        //     router.push({
        //         path: "/",
        //     })
        // }else{
        //     console.log(`异常请求：${JSON.stringify(error.message)}`)
        // }
        console.log(`异常请求：${JSON.stringify(error.message)}`)
    }
);
export default {
    own:axios,
    post(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url,
                data,
                //data: qs.stringify(data), //参数序列化
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                });
        })
    },

    get(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url,
                params: data,
            })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
};



